import Styled from 'styled-components';

export const TaskParentName = Styled.div`
	color: #A5A5AE;
	font-size: 11px;
`;